export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILED = 'AUTH_FAILED';

export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const USER_PROFILE_DATA = 'USER_PROFILE_DATA';

export const LOGOUT = 'LOGOUT';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export const IS_MAKE_PICK_CHOOSE = 'IS_MAKE_PICK_CHOOSE';
